import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject, Injector, Input, OnDestroy, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { IstekOlayTuru } from '@/src/service/fikoyt.istek.service';
import { debounce } from '@/src/service/fikoyt-ui/decorators/debounce';
import { NzWaveModule } from 'ng-zorro-antd/core/wave';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { RouterModule } from '@angular/router';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { FikoYTIstekSayfalama } from '@/src/service/modules/fikoyt-istek-kok/fikoyt-istek-sayfalama';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { escapeRegex } from '@/src/app/shared/utils/regex.utils';
// import { Debounce } from '../../FikoYT/decorators/FikoRator.decorators';


declare var $: any;

@Component({
  selector: 'fikoyt-dialog-kisi-secici',
  templateUrl: './dialog-kisi-secici.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, CommonModule, FormsModule, NzWaveModule, NzInputModule, NzButtonModule, NzIconModule, NzPaginationModule, NzPopconfirmModule, NzIconModule],
})
export class DialogKisiSeciciComponent extends FikoYTKokBilesenComponent implements OnDestroy {
  /** */
  @Input() pencere: any; // FikoDialogCore instance'ı
  /** */
  @Input() baslik = "Kişi Seçici";
  /** */
  @Input() saltOkunur = false;
  /** */
  private KISILER: any[] = [];
  public get kisiler(): any[] {
    return this.KISILER;
  }
  @Input() public set kisiler(v: any[]) {
    if (!v) v = [];
    this.KISILER = JSON.parse(JSON.stringify(v));;
    this.kisilerChange.emit(this.KISILER);
    // this.CD.detectChanges();
  }
  @Output() kisilerChange: EventEmitter<any[]> = new EventEmitter<any[]>();

  @Output() tiklandiKaydet: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() kapandi: EventEmitter<any[]> = new EventEmitter<any[]>();
  /** NOT:  Tanıdık Bulucu Değişkenler */
  kullanicilarIstek: FikoYTIstekSayfalama;

  aramaMetni?: string = '';


  constructor(@Inject(NZ_MODAL_DATA) public data: any,) {
    super();
    //@ts-ignore
    this.kullanicilarIstek = new FikoYTIstekSayfalama({
      metod: 'POST',
      komut: 'FikoYT.sistem.DB.goUyeler.aggregate',
      onEkOlsun: true,
      // parametreler: { aggregate: [] },
      filitreler: [
        // {
        //   $match: {
        //     uygulamalar: { $in: ["Uyar Döküm"] }
        //   }
        // },
      ],
      depoModu: false,
      oncelik: 0,
      gecikmeliCevap: false,
      gecikmeliCevapSuresi: 0,
      otoSonId: true,
      eklemeliListe: false,
    }).onMesgulDegisti(({ self, mesgul }) => {
      setTimeout(() => {
        this.CD.detectChanges();
      });
    })
      // .onCevap(({ self, sonuc }) => {
      //   console.log(sonuc);
      // })
      // .onOnceCevap(({ self, sonuc }) => {
      //   if (sonuc instanceof Array)
      //     return sonuc[0].liste ?? sonuc
      //   return sonuc
      // })

      .onHata(({ self, hatalar }) => {
        this.nzNotification.error("Hatalar Var", hatalar.map(hata => hata.mesaj).join("\n"));
      }).onTamamlandi(({ self }) => {
        // window.scrollTo({
        //   top: window.document.body.scrollHeight - window.innerHeight,
        //   behavior: 'smooth'
        // });
      })
      .iste();

  }

  override ngAfterViewInit(): void {
    this.kisiler = structuredClone(this.data?.kisiler ?? []);
  }

  // @debounce(10)
  degistiFilitre(value: any) {
    this.kullanicilarIstek.filitreler = [
      // {
      //   $match: {
      //     uygulamalar: { $in: ["Uyar Döküm"] }
      //   }
      // },
      {
        $addFields: {
          tamAd: {
            $concat: [
              { $ifNull: ["$isim", ""] },
              " ",
              { $ifNull: ["$soyIsim", ""] }
            ]
          }
        }
      }];
    this.kullanicilarIstek.filitreler.push({ $match: { tamAd: { $regex: escapeRegex(this.aramaMetni ?? ""), $options: "i" } } });
    // this.kullanicilarIstek.liste = [];
    this.kullanicilarIstek.listeyiSifirla();
  }




  tiklandiKullaniciKarti(k: any) {
    if (this.saltOkunur) return;

    let miKisiListesinde: boolean = false;

    this.kisiler.map((val: any, index: any) => {
      if (val._id == k._id) {
        miKisiListesinde = true;
        this.kisiler.splice(index, 1);
      }
    });

    if (!miKisiListesinde) {
      this.kisiler.splice(0, 0, k);
    }

    this.CD.detectChanges();
    this.kisilerChange.emit(this.kisiler);
  }

  kapa() {
    // Öncelik 1: NZ Modal (direkt açılmışsa)
    if (this.nzModalRef) {
      this.kapandi?.emit(); // EventEmitter varsa tetikle
      this.CD.detectChanges();
      this.nzModalRef.close();
      return;
    }

    // Öncelik 2: EventEmitter (varsa)
    this.kapandi?.emit();
    this.CD.detectChanges();

    // Öncelik 3: FikoDialogCore üzerinden kapat (wrapper içindeyse)
    if (this.pencere?.instance?.kapa) {
      this.pencere.instance.kapa();
      return;
    }
  }

  kaydetTiklandi() {
    this.CD.detectChanges();
    this.tiklandiKaydet.emit(this.kisiler ?? []);
    this.nzModalRef?.close({ kisiler: this.kisiler ?? [] });
  }


  miKisiListesinde(kisi: any) {
    let snc: boolean = false;
    this.kisiler.map(val => {
      if (val._id == kisi._id) { snc = true };
    });

    return snc;
  }

  trackByMethod(index: number, el: any): number {
    return el._id;
  }

  override ngOnDestroy(): void {
    // $("#dialogKisiSecici" + this.id_dialog).remove();
    this.kisilerChange.complete();
    this.tiklandiKaydet.complete();
    super.ngOnDestroy();
  }
}
